'use strict';

import React from 'react';
import PropTypes from 'prop-types';

class BaseFilter extends React.Component {
  getUserId () {
    return this.props.user && (this.props.user.getIn(['data', 'id']) || 0);
  }

  getUserIsAdmin () {
    return this.props.user && (this.props.user.getIn(['data', 'isAdmin'], false) || false);
  }

  getBool (name) {
    return Boolean(this.props.filter.get(name, false));
  }

  getValue (name) {
    return this.props.filter.get(name, null) || null;
  }

  getSelectedOptions () {
    return [...this.props.selectedOptions];
  }

  getNumber (name) {
    const val = this.getValue(name);
    return isNaN(parseInt(val)) ? null : parseInt(val);
  }

  handlerCheckbox (name) {
    return (id, select) => {
      const filter = {};
      filter[name] = (select ? 1 : null);

      this.props.onUpdate(filter);
    };
  }

  handlerSelect (name) {
    return (_, value) => {
      const filter = {};
      filter[name] = value;

      this.props.onUpdate(filter);
    };
  }

  handlerMyObjects (userId) {
    return (_, select) => {
      this.props.onUpdate({userId: select ? userId : null});
    };
  }

  render () {
    return null;
  }
}

BaseFilter.propTypes = {
  user: PropTypes.object,
  filter: PropTypes.object.isRequired,

  onUpdate: PropTypes.func.isRequired,
  selectedOptions: PropTypes.func.isRequired,
};

BaseFilter.defaultProps = {
  user: null
};

BaseFilter.defaultProps = {};

export default BaseFilter;



// WEBPACK FOOTER //
// ./src/ui/Search/Base.jsx